import React from "react";
import { useSearchParams } from "react-router-dom";
import RailDirectory from "./RailDirectory";
import RailResultsPage from "./RailResultsPage";

export default function RailHub() {
  const [searchParams] = useSearchParams();
  const hasSearch =
    searchParams.has("origin") &&
    searchParams.has("dest") &&
    searchParams.has("departDate");

  return hasSearch ? <RailResultsPage /> : <RailDirectory />;
}
